import { format_price } from "../../utils/cart-utils";
import productFormFormatMixin from "../mixins/product-form-format-mixin";

////////////////////
// Template
////////////////////
const template = /*html*/ `

<div class="c-product-form">

    <div class="c-product-form_inner || o-padding -padding-medium-top -padding-large-bottom">
        <div class="c-product-form_tag">
            <span v-if="isNew.trim() == 'true' && !isOutOfStock" class="c-tag">
                <span class="c-link_label">
                    <slot name="new"></slot>
                </span>
            </span>
            <span v-if="!isCurrentVariantExist" class="c-tag -alert">
                <span class="c-link_label">
                    <slot name="not-available"></slot>
                </span>
            </span>
            <span v-if="isOutOfStock" class="c-tag -alert">
                <span class="c-link_label">
                    <slot name="out-of-stock"></slot>
                </span>
            </span>
        </div>

        <!-- Title -->
        <h2 class="c-product-form_title">
            <slot name="title"></slot>
        </h2>

        <!-- Price -->
        <div class="c-product-form_price">
            <p class="c-product-form_price_current || c-text -subtitle">
                {{ currentVariantPrice }}
            </p>

            <!-- Price before discount -->
            <p class="c-product-form_price_original || c-text -body" v-if="currentOriginalVariantPrice">
                {{ currentOriginalVariantPrice }}
            </p>
        </div>

        <!-- Variants selectors -->
        <div class="c-product-form_selector">
            <product-form-selector
                v-if="option && option.values && option.values.length > 1"
                :label="option.name"
                :hasLabel="false"
                :values="option.values"
                :current-value="currentOptions[index]"
                :position="index"
                @onSelect="onOptionChange"
                v-for="(option, index) in options" :key="index"
            />
        </div>

        <!-- Manifold widget -->
        <div class="c-product-form_campaign-widget" v-if="!isOutOfStock">
            <slot name="manifold-campaign-widget"></slot>
        </div>

        <!-- Add to cart -->
        <div class="c-product-form_add">
            <button class="c-product-form_add_item || c-button -no-icon -fluid" :disabled="isNotAvailable" @click="onSubmit">
                <span class="c-button_label"><slot name="add-to-cart"></slot></span>
            </button>
        </div>
    </div>
</div>

`;


////////////////////
// Scripts
////////////////////
export default function VueProductForm(moduleInstance) {

    Vue.component("product-form", {

        template,

        mixins: [ productFormFormatMixin ],

        props: {
            variantsJson: {
                type: String,
                required: true
            },
            defaultCurrentVariantId: {
                type: String,
                required: true
            },
            optionsJson: {
                type: String,
                required: true
            },
            quantitiesJson: {
                type: String,
                required: true
            },
            colorsJson: {
                type: String,
                required: true
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            isNew: {
                type: Boolean,
                required: true
            },
            productType: {
                type: String
            }
        },

        data() {
            return {
                currentVariantItem: null,
                isCurrentVariantExist: true,
                quantity: 1,
            };
        },

        mounted() {
            this.refreshManifoldWidgets();
        },

        computed: {
            currentVariantName() {
                return this.isCurrentVariantExist ? this.currentVariantItem.optionsValues.join(' - ') : ''
            },

            currentVariantPrice() {
                return this.isCurrentVariantExist ? format_price(this.currentVariantItem.price, this.currencySymbol, this.currencyIsoCode) : '-'
            },

            currentOriginalVariantPrice() {
                return this.isCurrentVariantExist && this.currentVariantItem.compare_at_price ? format_price(this.currentVariantItem.compare_at_price, this.currencySymbol, this.currencyIsoCode) : ''
            },

            currentVariantQuantity() {
                return this.isCurrentVariantExist ? this.currentVariantItem.quantity : ''
            },

            currentVariantSale() {
                return this.isCurrentVariantExist && this.currentVariantItem.price && this.currentVariantItem.compare_at_price && this.currentVariantItem.price < this.currentVariantItem.compare_at_price  ? `-${100 - Math.round(this.currentVariantItem.price / this.currentVariantItem.compare_at_price * 100)}%` : ''
            },

            isNotAvailable() {
                return this.isOutOfStock || !this.isCurrentVariantExist
            },

            isOutOfStock() {
                return this.isCurrentVariantExist && !this.currentVariantItem.available
            }
        },

        created() {
            this.variantItems = this.variantsJson ? JSON.parse(this.variantsJson) : []
            this.options = this.optionsJson ? JSON.parse(this.optionsJson) : []

            const currentVariantItemId = this.defaultCurrentVariantId ? JSON.parse(this.defaultCurrentVariantId) : null
            const quantities = this.quantitiesJson ? JSON.parse(this.quantitiesJson) : []
            const colors = this.colorsJson ? JSON.parse(this.colorsJson) : []

            // Update options
            this.formatOptions(this.options)

            // Update variantItems
            this.formatVariantsItems(this.variantItems, this.options, quantities, colors)

            // Update options colors
            this.formatOptionsColors(this.options, this.variantItems)

            // Set current product variant
            this.currentVariantItem = this.variantItems.find(variant => variant.id === currentVariantItemId)

            // Set current options
            this.currentOptions = this.currentVariantItem.options.map(option => option.value)
        },

        methods: {
            /////////////////
            // Callbacks
            /////////////////

            onOptionChange(newOption) {
                // Update new current options
                this.currentOptions[newOption.position] = newOption.value

                // Update current variant item
                this.updateCurrentVariant()

                // Log state
                // this.logProductFormState()
            },

            onUpdateQuantity(newQuantity) {
                // Update quantity
                this.quantity = newQuantity

                // Log state
                // this.logProductFormState()
            },

            onSubmit() {
                moduleInstance.call('addItem', {
                    "id": this.currentVariantItem.id,
                    "quantity": 1
                }, 'Cart')
            },

            /////////////////
            // Methods
            /////////////////

            /**
            * Update current product variant and set exist state
            */
            updateCurrentVariant() {
                const currentOptionsId = this.currentOptions.join('')

                this.currentVariantItem = this.variantItems.find(variantItem => variantItem.optionsValues.join('') === currentOptionsId )

                if (!this.currentVariantItem) {
                    this.isCurrentVariantExist = false
                } else {
                    this.isCurrentVariantExist = true
                    // Update url
                    this.updateUrl(this.currentVariantItem.id)

                    if(this.productType == 'Manifold') {
                        this.refreshManifoldWidgets();
                    }
                }
            },

            /**
            * Update current url with variant parameter
            */
            updateUrl(variantId) {
                if (!variantId) return

                const url = new URL(window.location);
                url.searchParams.set('variant', variantId);
                window.history.replaceState({}, '', url);
            },

            refreshManifoldWidgets() {
                // deprecated
                // window.dispatchEvent(new CustomEvent("m-refresh-widgets"));
            },

            /**
            * Log state
            */
            logProductFormState() {
                console.group('Product form state')
                    console.log('gid', this.currentVariantItem && this.currentVariantItem.gid)
                    console.log('currentItem', this.currentVariantItem)
                    console.log('currentOptions', this.currentOptions)
                    console.log('options', this.options)
                    console.log('quantity', this.quantity)
                    console.log('quantityMax', this.currentVariantItem && this.currentVariantItem.quantity)
                    console.log('currentVariantName', this.currentVariantName)
                    console.log('currentVariantPrice', this.currentVariantPrice)
                    console.log('currentOriginalVariantPrice', this.currentOriginalVariantPrice)
                    console.log('currentVariantSale', this.currentVariantSale)
                    console.log('isNotAvailable', this.isNotAvailable)
                    console.log('isOutOfStock', this.isOutOfStock)
                    console.log('isQuantityNotAvailable', this.isQuantityNotAvailable)
                console.groupEnd()
            }
        }
    });
}
